import { useSubjectMember } from '@healthblocks-io/core'
import { t } from '@lingui/macro'

import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H1 } from '@/@bothrs-ui/web/components/typography/Heading'
import { FloatingLayoutBox } from '@/layout/components/floating-layout/FloatingLayout.styled'
import { getDropInProps } from '@/modules/shared/animations/dropIn.animation'

export const IntroductionBox = ({ onStartConfirmation }: { onStartConfirmation: () => void }) => {
  const subject = useSubjectMember()

  return (
    <FloatingLayoutBox key='personal-contact-information-intro' {...getDropInProps()}>
      <H1>{t({ message: 'Welkom, {name}', values: { name: subject?.givenName } })}</H1>
      <P type='BodyMediumRegular'>
        {t({
          id: 'onboarding.personal-contact-information.intro',
          message:
            'Met MijnZiekenhuis willen we je zo goed mogelijk begeleiden. Daarvoor hebben we een aantal actuele gegevens van je nodig.',
        })}
      </P>

      <Button variant='Primary' onClick={onStartConfirmation}>
        {t({
          id: 'onboarding.personal-contact-information.start',
          message: 'Controleer je gegevens',
        })}
      </Button>
    </FloatingLayoutBox>
  )
}
